import { z } from 'zod';

const MAX_FILE_BYTES = 5 * 1024 * 1024;
export const TICKET_ATTACHMENT_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
export const MAX_TICKET_ATTACHMENTS = 5;

// billing/kyc/technical/other — the only four categories the real API
// accepts on ticket creation (and the only ones the admin queue's category
// filter offers).
export const TICKET_CATEGORIES = [
  { value: 'billing', label: 'Billing' },
  { value: 'kyc', label: 'KYC' },
  { value: 'technical', label: 'Technical' },
  { value: 'other', label: 'Other' },
];
const TICKET_CATEGORY_VALUES = TICKET_CATEGORIES.map((c) => c.value);

// Single-file rule, shared by the new-ticket form and the reply box on both
// investor and admin sides: jpg/jpeg/png/pdf, max 5MB. Client-side
// pre-check only — the server is the real source of truth.
export const ticketAttachmentSchema = z
  .instanceof(File)
  .refine((file) => TICKET_ATTACHMENT_MIME_TYPES.includes(file.type), 'Must be a JPG, PNG, or PDF file.')
  .refine((file) => file.size <= MAX_FILE_BYTES, 'Each file must be 5MB or smaller.');

const ticketAttachmentsField = z
  .array(ticketAttachmentSchema)
  .max(MAX_TICKET_ATTACHMENTS, `Up to ${MAX_TICKET_ATTACHMENTS} attachments allowed.`)
  .optional();

// POST /investor/support-tickets
export const newTicketSchema = z.object({
  subject: z.string().min(1, 'Subject is required'),
  category: z.enum(TICKET_CATEGORY_VALUES, { errorMap: () => ({ message: 'Select a category' }) }),
  body: z.string().min(1, 'Please describe your issue'),
  attachments: ticketAttachmentsField,
});

// POST .../messages — reply, either side.
export const ticketReplySchema = z.object({
  body: z.string().min(1, 'Message cannot be empty'),
  attachments: ticketAttachmentsField,
});

export default newTicketSchema;
